import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, useIntl } from "react-intl"
import { RadioGroupStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupStep"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"

const isInfertilityDxOptions = [
  { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
  { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
]

export function RelatedToInfertilityDiagnosisStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { isInfertilityDx }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const formattedOptions = useConvertTranslatedLabel(isInfertilityDxOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({
      type: "UPDATE_FIELD",
      field: "isInfertilityDx",
      value: formValues.isInfertilityDx
    })
    send("")
  }

  return (
    <RadioGroupStep
      title={intl.formatMessage({
        defaultMessage: "Is the care related to an infertility diagnosis issued by an eligible fertility provider?"
      })}
      description={intl.formatMessage({
        defaultMessage:
          "If you're not sure, ask your provider. This helps us determine if the care may be a qualified medical expense."
      })}
      name="isInfertilityDx"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={isInfertilityDx}
    />
  )
}
